import { types, flow, castToSnapshot } from 'mobx-state-tree';
import { navigate } from 'js/services/Network';
import { pick } from 'lodash';

import { makeRequest, url } from 'js/services/Network';
import { castEventToValue } from 'js/services/FormTools';
import analytics from 'js/services/Analytics';

import SteppedPage from 'js/stores/SteppedPage';
import CreditCard from 'js/stores/types/CreditCard';
import AppState from "js/stores/AppState";
import BankAccount from 'js/stores/types/BankAccount';

const CreateTokenPageState = types
  .model('CreateTokenPage', {
    modalIsVisible: false,
    error: types.maybeNull(types.string),

    hasEnteredTitle: false,
    hasEnteredPrice: false,

    title: '',
    price: '',
    credit_card: types.optional(CreditCard, {}),
    bank_account: types.optional(BankAccount, {}),
  })
  .actions(self => {
    return {
      getStepRoute(step) {
        return url('create-offer-page', {
          step,
        });
      },

      initStep(step) {
        self.modalIsVisible = false;
        return self;
      },

      afterCreate() {
        self.title = new URLSearchParams(window.location.search).get('title') || '';
        self.hasEnteredTitle = self.title.length > 0;
      },

      load: flow(function* load() {
        const response = yield makeRequest('create-offer-data');
        if(response.data.credit_card && !response.data.credit_card.address.formatted_address){
          response.data.credit_card.address = {};
        }
        self.credit_card = response.data.credit_card;

        return response;
      }),

      submit: flow(function* submit() {
        let response;
        if (!self.isSubmitting) {
          self.isSubmitting = true;
          self.error = null;

          try {
            response = yield makeRequest('create-offer', self, pick(self, ['title', 'price', 'credit_card', 'bank_account']));
            // analytics.track('CC_created coupon');

            const alias = response.data.alias;

            analytics
              .track('Offer Link Created', {
                'Item Price': self.price,
                'Item Name': self.title,
                'Item Size': self.size,
                'Payment Link': url('token-page', { alias }),
                'Location': AppState.currentPage,
                'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
                  ? 'seller' : 'buyer'
              });

            navigate(url('status-page', response.data));
          } catch (error) {
            self.error = error.response.data.message || error.response.statusText;
          }

          self.isSubmitting = false;
        }
        return response;
      }),

      openModal() {
        self.modalIsVisible = true;
        return self;
      },
      closeModal() {
        self.modalIsVisible = false;
        return self;
      },

      nextDetail() {
        if (!self.hasEnteredTitle && self.title) {
          self.hasEnteredTitle = true;
        } else if (!self.hasEnteredPrice && self.price && parseInt(self.price) > 0) {
          self.hasEnteredPrice = true;
        } else {
          self.nextStep();
        }
      },
      setTitle(title) {
        self.title = castEventToValue(title);
      },
      setPrice(price) {
        self.price = castEventToValue(price);
      },
      creditCardSaved(creditCard) {
        self.credit_card.setCreditCard(castToSnapshot(creditCard));
        self.modalIsVisible = false;
      },
    };
  });

export default types.compose(
  SteppedPage,
  CreateTokenPageState,
);
